import { atom } from 'jotai';

export const plansViewingAtom = atom<'active' | 'archived'>('active');
